import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import AdditionalInfo from '@/Pages/AdditionalInfo';

const PreviewModal = ({ isOpen, onClose, formData, currentRoom }) => {
  if (!formData || !currentRoom) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-5xl h-[90vh] overflow-auto">
        <DialogHeader>
          <DialogTitle>Preview: {formData[currentRoom]?.header}</DialogTitle>
        </DialogHeader>
        <AdditionalInfo previewMode={true} previewData={formData[currentRoom]} previewType={currentRoom} />
      </DialogContent>
    </Dialog>
  );
};

export default PreviewModal;